import { useEffect, useState } from 'react';
import ENDPOINTS from '../reducers/endpoints.const';
import {
  // SEOAEMProps,
  TCardAemProp,
  TCardContainerAemProp,
  TDisclosureContainerAemProp,
  TSectionAemProp,
  TSeoConfigAemProp,
} from '../model/AemDataProps';

const AEM_API_HOST = window?.ENV_CONFIG?.AEM_API_HOST;
const AEM_EU_LANDING_PAGE_URL = AEM_API_HOST + ENDPOINTS.AEM_EU_LANDING_PAGE.path;

export const useAemEuLandingPage = (country: string, aemLanguage: string) => {
  const [seoAemProps, setSeoAemProps] = useState<TSeoConfigAemProp>();
  const [sectionOneAemProps, setSectionOneAemProps] = useState<TSectionAemProp>();
  const [imageVideoCardAemProps, setImageVideoCardAemProps] = useState<TCardAemProp>();
  const [sectionTwoAemProps, setSectionTwoAemProps] = useState<TSectionAemProp>();
  const [cardCollectionOneAemProps, setCardCollectionOneAemProps] =
    useState<TCardContainerAemProp>();
  const [sectionThreeAemProps, setSectionThreeAemProps] = useState<TSectionAemProp>();
  const [cardCollectionTwoAemProps, setCardCollectionTwoAemProps] =
    useState<TCardContainerAemProp>();
  const [disclosureContainerAemProps, setDisclosureContainerAemProps] =
    useState<TDisclosureContainerAemProp>();

  useEffect(() => {
    const fetchDataForEULandingPage = async () => {
      const response = await fetch(
        AEM_EU_LANDING_PAGE_URL.replace('{{country-code}}', country).replace(
          '{{language}}',
          aemLanguage,
        ),
      )
        .then((res) => res.json())
        .then((jsonData) => {
          const data: string = JSON.stringify(jsonData.data.componentRefs).replace(
            /<\/p>(?=\s*<p>)/g,
            '</p><br>',
          );
          return JSON.parse(data);
        });

      // seo content
      setSeoAemProps(response.seoconfig.props);

      // page-heading
      setSectionOneAemProps(response['section-1'].props);

      // image-video-1
      setImageVideoCardAemProps(response['image-video-1'].props);

      // section-2
      setSectionTwoAemProps(response['section-2'].props);
      setCardCollectionOneAemProps(response['card-collection-1'].props);

      // section-3
      setSectionThreeAemProps(response['section-3'].props);
      setCardCollectionTwoAemProps(response['card-collection-2'].props);

      //Disclaimer
      if (response['disclosure-container']) {
        const disclosureContent = JSON.stringify(response['disclosure-container'].props).replace(
          /<\/?p>|<\/p><br>/g,
          '',
        );
        setDisclosureContainerAemProps(JSON.parse(disclosureContent));
      }
    };
    fetchDataForEULandingPage();
  }, []);
  return {
    seoAemProps,
    sectionOneAemProps,
    sectionTwoAemProps,
    sectionThreeAemProps,
    cardCollectionOneAemProps,
    cardCollectionTwoAemProps,
    imageVideoCardAemProps,
    disclosureContainerAemProps,
  };
};
